import React, { forwardRef, useEffect, useState ,useRef} from 'react'
import { useHistory } from 'react-router-dom'
import { Row, Col, Card, Form, Button, InputGroup } from 'react-bootstrap'
import Select from 'react-select'
import moment from 'moment'
import FeatherIcon from 'feather-icons-react'
import Table from '../../../components/Table/DataTable'
import initialData from './MockData'
import { debounceCallback,cancelDebounceCallback } from '../../../utility/debounceCallback.util'
import httpClient from '../../../utility/httpClient.util'
import { useTimeFormat } from 'contexts/TimeFormatContext'
import NewFormModal from './NewFormModal'

const FormAssessment = () => {
  const tableRef = useRef();
  const {formatDate} = useTimeFormat()
  const history = useHistory()
  const [category, setCategory] = useState({})
  const [formName, setFormName] = useState('')
  const [data, setData] = useState([])
  const [categoryOptions, setCategoryOptions] = useState([])
  const [showForm,setShowForm] = useState(false)
  const [loading,setLoading] = useState(false)
  const [isReady, setIsReady] = useState(false);
  const refreshFromFirstPage = () => {
    tableRef.current && tableRef.current.onQueryChange({ page: 0 })
  }
  const columns = [
    {
      title: 'No', 
      align: 'center',
      render: (rowData) => rowData.tableData.id + 1 + (tableRef.current.state.pageSize * tableRef.current.state.query.page), // Display row index
      cellStyle: { width: '25px', textAlign: 'center' }, // Set small width for cells
      headerStyle: { width: '25px', textAlign: 'center' }, // Set small width for header
    },
    {
      title: 'Category',
      field: 'category',
      align: 'center',
      render: ({ formAssessmentCategoryManage }) => {
        if (formAssessmentCategoryManage) {
          return formAssessmentCategoryManage[0]?.formAssessmentCategory?.code || ''
        } else {
          return ''
        }
      },
    },
    {
      title: 'Name',
      field: 'name',
    },
    {
      title: 'Code',
      field: 'code',
      align: 'left',
    },
    {
      title: 'Version',
      field: 'formAssessmentRevision',
      align: 'center',
      render: ({ formAssessmentRevision }) => formAssessmentRevision?.version,
    },
    {
      title: 'Updated By',
      field: 'updatedBy.firstName',
      align: 'center',
      render: ({updatedBy,updatedAt})=>{
        return (<div>{updatedBy?.firstName} - {updatedAt ? formatDate(moment(updatedAt)) : '-'}</div>)
      }
    },
    {
      title: 'Visible',
      field: 'isVisible',
      align: 'center',
      render: (rowData) => {

        return rowData.isVisible===1 ? (<FeatherIcon
            id={`check-${rowData.id}`}
            icon="check-circle"
            size="24"
            className="text-c-green"
            style={{ cursor: 'pointer' }}
          />):(<FeatherIcon
            id={`check-${rowData.id}`}
            icon="x-circle"
            size="24"
            className="text-c-red"
            style={{ cursor: 'pointer' }}
          />)
      },
    },
  ]

  const onRowClick = (_, row) => {    
    history.push({
      pathname: `${history.location.pathname}/${row.formAssessmentId}`,
    })
  }

  const onChangeText = async (value) => {
    setFormName(value)
  }

  const getFormAssessment = async () => {
    setLoading(true)
    let url = `/designer/form-assessment/dashboard?page=1&perPage=20&include=formAssessmentCategoryManage.formAssessmentCategory,formAssessmentRevision,updatedBy`
    let api = ''
    if (category?.formAssessmentCategoryId && formName !== '') {
      api =
        url +
        `&name=${formName}&formAssessmentCategoryManage.formAssessmentCategoryManageId=eq.${category?.formAssessmentCategoryId}`
    } else if (category?.formAssessmentCategoryId) {
      api =
        url +
        `&formAssessmentCategoryManage.formAssessmentCategoryManageId=eq.${category?.formAssessmentCategoryId}`
    } else if (formName !== '') {
      api = url + `&name=${formName}`
    } else {
      api = url
    }
    const res = (await httpClient.get(api).then(({ data }) => data)).data
    if (res.length) {
      setData(res)
    } else {
      setData([])
    }
    setLoading(false)
  }



  const getCategory = async () => {
    const res = (await httpClient.get(`/designer/form-assessment-category`))?.data || []
    
    if (res?.data?.length) {
      setCategoryOptions(res.data.map(({code,name,formAssessmentCategoryId})=>{return {label:code+" - "+name,value:code,formAssessmentCategoryId:formAssessmentCategoryId}}))
    } else {
      setCategoryOptions([])
    }
    setIsReady(true);
  }

  useEffect(() => {
    //getFormAssessment()
    if(isReady)
      refreshFromFirstPage()
  }, [isReady,category])

  useEffect(() => {
    getCategory()
  }, [])

  const handleChange = (e) => {
    const value = e.target.value;
    if (e.key === 'Enter') {
      e.preventDefault();
      cancelDebounceCallback('search');
      //getFormAssessment()
      refreshFromFirstPage()
    } else {
      //debounceCallback(getFormAssessment, [value], 'search', 1500);
    }
  };

  return (
    <Card>
      <Card.Header>
        <Card.Title>Form Assessment</Card.Title>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col>
            <Form.Group as={Row}>
              <Form.Label column sm={1} className='text-right p-r-0'>
                Category
              </Form.Label>
              <Col sm={3}>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  placeholder="category"
                  name="category"
                  options={categoryOptions}
                  onChange={(e) => setCategory(e)}
                  isClearable
                />
              </Col>
              <Form.Label column sm={2} className='text-right p-r-0'>
                Form Code / Name
              </Form.Label>
              <Col sm={6}>
                
                <InputGroup >
                  <Form.Control
                    type="text"
                    value={formName}
                    placeholder='Search...'
                    onKeyDown={handleChange}
                    onChange={(e) =>{onChangeText(e.target.value)}}                    
                  />
                  <InputGroup.Prepend style={{cursor:'pointer'}} onClick={refreshFromFirstPage}>
                    <InputGroup.Text><i className="fas fa-search" /></InputGroup.Text>
                  </InputGroup.Prepend>    
                  <InputGroup.Prepend style={{cursor:'pointer'}} onClick={()=> setFormName('')}>
                    <InputGroup.Text><i className="fas fa-trash" /></InputGroup.Text>
                  </InputGroup.Prepend>              
                </InputGroup>        
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col className="d-flex justify-content-end my-2">
            <Button
              variant="outline-primary"
              onClick2={() => history.push(`${history.location.pathname}/add`)}
              onClick={()=>setShowForm(true)}
            >
              <i className="fas fa-plus mr-2" />
              Create Form
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <Table
              isLoading={loading}    
              tableRef={tableRef}        
              columns={columns}
              data={query =>
                new Promise(async (resolve, reject) => {
                  if (!isReady) {
                    resolve({
                      data:[],page:0,totalCount:0
                    })
                    return;
                  }
                  let url = `/designer/form-assessment/dashboard?page=${query.page + 1 }&perPage=${query.pageSize}&include=formAssessmentCategoryManage.formAssessmentCategory,formAssessmentRevision,updatedBy`
                  let api = ''
                  if (category?.formAssessmentCategoryId && formName !== '') {
                    api =
                      url +
                      `&name=${formName}&categoryId=${category?.formAssessmentCategoryId}`
                  } else if (category?.formAssessmentCategoryId) {
                    api =
                      url +
                      `&categoryId=${category?.formAssessmentCategoryId}`
                  } else if (formName !== '') {
                    api = url + `&name=${formName}`
                  } else {
                    api = url
                  }
                  const res = (await httpClient.get(api).then(({ data }) => data))
                  resolve({
                    data:res.data,
                    page: res.pagination.page - 1,
                    totalCount: res.pagination.total
                  })
                })
              }
              actions={[
                {
                  icon: forwardRef((props, ref) => (
                    <i className="fas fa-eye" {...props} ref={ref} />
                  )),
                  tooltip: 'Preview',
                  onClick: (event, rowData) => {
                    window.open(
                      `/#${history.location.pathname}/${rowData.formAssessmentId}/preview`,
                      '_blank',
                    )
                  },
                },
              ]}
              options={{
                search: false,
                actionsColumnIndex: -1,
                toolbar: false,
                pageSize: 20,
                headerStyle: {
                  textAlign: 'center',
                  textOverflow: 'clip',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                },
                cellStyle: {
                  minWidth: 120,
                  maxWidth: 300,
                  textOverflow: 'clip',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                },
              }}
              onRowClick={onRowClick}
            />
          </Col>
        </Row>
      </Card.Body>
      <NewFormModal show={showForm} onHide={()=>setShowForm(false)} />
    </Card>
  )
}

export default FormAssessment
